import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePageNew.js';
import CertificateVerify from './components/CertificateVerify';
import CompanyProfile from './components/CompanyProfile';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AboutPage from './pages/AboutPage';
import GalleryPage from './pages/GalleryPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import TrainingCertificationPage from './pages/TrainingCertificationPage';
import CompanyAbout from './pages/company/CompanyAbout';
import CompanyServices from './pages/company/CompanyServices';
import CompanyContact from './pages/company/CompanyContact';
import useScrollReveal from './hooks/useScrollReveal';
import './styles/global.css';
import './styles/reveal.css';

function ProtectedRoute({ children }) {
  const token = localStorage.getItem('adminToken');
  return token ? children : <Navigate to="/admin/login" />;
}

// Router-agnostic so the prerender script can mount it under a StaticRouter
// instead of the BrowserRouter used in the browser.
export function AppShell() {
  const { pathname } = useLocation();
  useScrollReveal(pathname);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <main style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/verify" element={<CertificateVerify />} />
          <Route path="/verify/:certificateId" element={<CertificateVerify />} />
          <Route path="/verify/*" element={<CertificateVerify />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route
            path="/company/:id"
            element={<CompanyProfileRoute />}
          />
          <Route path="/company/:id/about" element={<CompanyAbout />} />
          <Route path="/company/:id/services" element={<CompanyServices />} />
          <Route path="/company/:id/contact" element={<CompanyContact />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route
            path="/training-certification"
            element={<TrainingCertificationPage />}
          />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

function CompanyProfileRoute() {
  const { id } = require('react-router-dom').useParams();
  return <CompanyProfile companyId={id} />;
}

export default App;
